import http from "../axios-instance";

class MasterOrderService {
	async sendOrderToBoss(order_id, data = {}) {
		return http
			.post(`/order/${order_id}/send_boss`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	async sendAgentOrderToBoss(order_id, data = {}) {
		return http
			.post(`/agent_order/${order_id}/send_boss`, data, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	getOrders() {
		return http
			.get("/master_order")
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	getOrder(order_id) {
		return http
			.get(`/master_order/${order_id}`)
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	downloadNewFile(order) {
		return http
			.get(`/master_order/${order._id}/download_new_file`, {
				responseType: "blob",
			})
			.then((res) => {
				const fileName =
					order?.modified_file || this.getFileNameFromHeaders(res.headers);
				this.download(res.data, fileName);
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	downloadOldFile(order) {
		return http
			.get(`/master_order/${order._id}/download_old_file`, {
				responseType: "blob",
			})
			.then((res) => {
				const fileName =
					order?.original_file || this.getFileNameFromHeaders(res.headers);
				this.download(res.data, fileName);
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	getFileNameFromHeaders(headers) {
		const contentDisposition =
			headers?.["content-disposition"] || headers?.["Content-Disposition"];
		if (!contentDisposition) return "";

		// Example: attachment; filename="somefile.zip"
		const match = contentDisposition.match(
			/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i,
		);
		if (!match) return "";

		return String(match[1] || "")
			.trim()
			.replace(/^['"]|['"]$/g, "");
	}

	download(data, fileName) {
		let blob = new Blob([data], {
			type: "application/octet-stream",
		});
		let downloadElement = document.createElement("a");
		let href = window.URL.createObjectURL(blob);
		downloadElement.href = href;
		const safeName = fileName || "download";
		const extracted = String(safeName).match(/__fn__(.+)/);
		downloadElement.download = extracted?.[1] || String(safeName);
		document.body.appendChild(downloadElement);
		downloadElement.click();
		document.body.removeChild(downloadElement);
		window.URL.revokeObjectURL(href);
	}
}

export default new MasterOrderService();
